import { addVariant } from "../../olipop/components/Buttons/oli-button-action";


export const buildRebuyRecommendations = () => {
  if (!customElements.get('rebuy-recommendations')) {
    customElements.define('rebuy-recommendations', class rebuyRecommendations extends HTMLElement {
      constructor() {
        super();
        this.widgetId = this.dataset.widgetId;
        this.rootUrl = this.dataset.rootUrl;
        this.productGrid = this.querySelector('.js-rebuy-product-grid');
        if (!this.widgetId) return

        document.addEventListener('rebuy.loaded', this.initWidget.bind(this));
        this.initWidget();
      }

      initWidget() {
        const widget = window.Rebuy.widgets?.find((w) => w.id === this.widgetId);
        if (!widget) return


        const checkProducts = setInterval(() => {
          if (widget.data.products) {
            this.widgetProducts = widget.data.products;
            clearInterval(checkProducts);
            this.getProductCards();
          }
        }, 200);
      }

      getProductCards() {
        const fetchPromises = this.widgetProducts.map(product => fetch(`${this.rootUrl}products/${product.handle}?view=product-card`));

        Promise.all(fetchPromises)
          .then(responses => {
            responses.forEach(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
            });

            return Promise.all(responses.map(response => response.text()));
          })
          .then(data => {
            this.renderProducts(data);
            this.initATCButtons();
          })
          .catch(error => {
            console.error(error);
          });

      }

      renderProducts(data) {
        if (!data.length) {
          this.closest('.shopify-section').classList.add('hidden')
          return
        }
        data.forEach(item => {
          const parsedCard = new DOMParser().parseFromString(item, 'text/html').querySelector('.product-card');
          if (!parsedCard) return
          this.productGrid.insertAdjacentElement("beforeend", parsedCard);
        });
      }

      initATCButtons() {
        const buttons = this.querySelectorAll('[data-action="add-variant"]');
        if (buttons.length) {
          buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              addVariant(btn);
            });
          })
        }
      }
    });
  }

};
